import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="logo-icon">  <i className="fa-solid fa-feather-pointed logo-icon"></i></span>
              <span>Roamio</span>
            </div>
            <p className="footer-tagline">
              Discover extraordinary stays around the world. Your next adventure begins here.
            </p>
            <div className="footer-social">
              <a href="https://instagram.com/daaldhokali" className="social-link" aria-label="Instagram"><i class="fa-brands fa-instagram"></i></a>
              <a href="https://github.com/kalpana-chavhan" className="social-link" aria-label="github"><i class="fa-brands fa-github"></i></a>
              <a href="https://discord.gg/hTKzmak" className="social-link" aria-label="discord"><i class="fa-brands fa-discord"></i></a>
              <a href="https://pinterest.com/iblamekru" className="social-link" aria-label="Pinterest"><i class="fa-brands fa-pinterest"></i></a>
            </div>
          </div>

          <div className="footer-links-group">
            <h4>Explore</h4>
            <ul>
              <li><Link to="/hotels">All Hotels</Link></li>
              <li><Link to="/hotels?type=resort">Resorts</Link></li>
              <li><Link to="/hotels?type=villa">Villas</Link></li>
              <li><Link to="/hotels?type=boutique">Boutique</Link></li>
            </ul>
          </div>

          <div className="footer-links-group">
            <h4>Company</h4>
            <ul>
              <li><a href="#">About Us</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Press</a></li>
              <li><a href="#">Blog</a></li>
            </ul>
          </div>

          <div className="footer-links-group">
            <h4>Support</h4>
            <ul>
              <li><a href="#">Help Center</a></li>
              <li><a href="#">Contact Us</a></li>
              <li><a href="#">Privacy Policy</a></li>
              <li><a href="#">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Roamio. All rights reserved.</p>
          <div className="footer-payments">
            <span className="payment-badge">VISA</span>
            <span className="payment-badge">MC</span>
            <span className="payment-badge">AMEX</span>
            <span className="payment-badge">PayPal</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
